// extracted by mini-css-extract-plugin
export default {"animateWormBag":"WormsAnimation_animateWormBag__brINR","wormBag":"WormsAnimation_wormBag__4VDY3","worms2":"WormsAnimation_worms2__UtDGG","worms3":"WormsAnimation_worms3__gNCqy"};